import { combineReducers } from 'redux'
import annualPurchasePlanReducer from '../../containers/AnnualPurchasePlanSection/AnnualPurchasePlanSection.reducer'
import authorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import { averagePayReducer, totalPurchasesReducer } from '../../containers/SummarySection/SummarySection.reducer'
import basicBuyerInformationReducer from '../../containers/BasicBuyerInformationSection/BasicBuyerInformationSection.reducer'
import claimListReducer from '../../containers/ClaimsReceivedSection/ClaimsReceivedSection.reducer'
import claimTableReducer from '../../containers/ClaimsReceivedChartSection/ClaimsReceivedChartSection.reducer'
import dependentBuyerReducer from '../../containers/DependentBuyerSection/DependentBuyerSection.reducer'
import institutionalManagementReducer from '../../containers/InstitutionalManagementSection/InstitutionalManagementSection.reducer'
import outsideAnnualPurchasePlanReducer from '../../containers/OutsideAnnualPurchasePlanSection/OutsideAnnualPurchasePlanSection.reducer'
import publicProcurementCourtClaimsReducer from '../../containers/PublicProcurementCourtClaimsSection/PublicProcurementCourtClaimsSection.reducer'
import snackbarProviderReducer from '../../containers/SnackbarProvider/SnackbarProvider.reducer'
import totalPurchaseOrdersReducer from '../../containers/PurchaseOrdersSection/PurchaseOrdersSection.reducer'
import pdfDataReducer from '../../containers/PDF/ToDownload.reducer'
import behaviorSectionReducer from '../../containers/BehaviorSection/BehaviorSection.reducer'

export default combineReducers({
  annualPurchasePlan: annualPurchasePlanReducer,
  authorizationProvider: authorizationProviderReducer,
  averagePay: averagePayReducer,
  basicBuyerInformation: basicBuyerInformationReducer,
  claimInformation: claimListReducer,
  claimInformationTable: claimTableReducer,
  dependentBuyer: dependentBuyerReducer,
  institutionalManagement: institutionalManagementReducer,
  outsideAnnualPurchasePlan: outsideAnnualPurchasePlanReducer,
  pdfData: pdfDataReducer,
  publicProcurementCourtClaims: publicProcurementCourtClaimsReducer,
  snackbarProvider: snackbarProviderReducer,
  totalPurchaseOrders: totalPurchaseOrdersReducer,
  totalPurchases: totalPurchasesReducer,
  behaviorSection: behaviorSectionReducer
})
